import React from "react";
import { HomeLayout } from "../layout/HomeLayout";
import { HomeHero } from "../home/HomeHero";
import { PillarCards } from "../home/PillarCards";
import { HomeClassesIndex } from "../home/HomeClassesIndex";
import { TeacherWorkshopPanel } from "./TeacherWorkshopPanel";
import { useTeacherDashboard } from "../../hooks/useTeacherDashboard";

export const TeacherDashboardView: React.FC = () => {
  const d = useTeacherDashboard();

  return (
    <HomeLayout>
      <div className="mx-auto flex max-w-7xl flex-col gap-12 px-8 pb-20">
        <HomeHero
          compact
          greeting={`Hola,\n${d.teacherName}`}
          tagline="Gestiona clases, tareas y el progreso de tus alumnos."
          stats={[
            { value: d.activeTasks.length, label: "Activas" },
            { value: d.totalStudents, label: "Estudiantes" },
            { value: `${d.globalAverage}%`, label: "Promedio" },
            { value: d.totalSubmissions, label: "Entregas" },
          ]}
        />

        <PillarCards />

        <HomeClassesIndex isTeacher />

        <TeacherWorkshopPanel noDivider />
      </div>
    </HomeLayout>
  );
};
